module.exports = __webpack_public_path__ + "img/alxq2.e951ac0e.png";